import { render, staticRenderFns } from "./upAuthDialog.vue?vue&type=template&id=24076aae&scoped=true&"
import script from "./upAuthDialog.vue?vue&type=script&lang=js&"
export * from "./upAuthDialog.vue?vue&type=script&lang=js&"
import style0 from "./upAuthDialog.vue?vue&type=style&index=0&id=24076aae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24076aae",
  null
  
)

export default component.exports